import { computed, ref } from 'vue';
import z from 'zod';

import { OrgCardSchema } from '@/src/store/ocg-app-state';
import { supabase } from '@/src/supabase';

export const RoleRowSchema = z.object({
  id: z.string().nonempty(),
  org: z.string().nonempty(),

  org_card: OrgCardSchema,
  name: z.string(),
  description: z.string(),
});

export type RoleRow = z.infer<typeof RoleRowSchema>;

export function roleChipLabel(item: RoleRow | undefined): string {
  if (!item) return '';
  return `${item.org_card.fn}: ${item.description}`;
}

export function useRoles() {
  const roles = ref<RoleRow[]>([]);

  async function loadRoles() {
    const { data, error } = await supabase.from('role_details').select();
    if (error) throw error;
    roles.value = z.array(RoleRowSchema).parse(data);
  }

  const roleAutocompleteItems = computed(() =>
    roles.value.map(role => ({
      title: roleChipLabel(role),
      value: role.id,
    })),
  );

  return {
    roles,
    loadRoles,
    roleAutocompleteItems,
  };
}
